import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import BodyText from 'components/Luxkit/Typography/BodyText'
import Heading from 'components/Luxkit/Typography/Heading'
import Group from 'components/utils/Group'
import React from 'react'
import ModalBase from 'components/Luxkit/Modal/ModalBase'
import ModalBody from 'components/Luxkit/Modal/ModalBody'
import ModalImageThumbnail from 'components/Luxkit/Modal/ModalImageThumbnail'
import ModalContent from 'components/Luxkit/Modal/ModalContent'
import ModalHeader from 'components/Luxkit/Modal/ModalHeader'
import LoyaltyTierCallOutBanner from 'loyalty/components/LoyaltyTierCallOutBanner'
import getLoyaltyTierDisplayName from 'loyalty/selectors/getLoyaltyTierDisplayName'
import Plural from 'components/utils/Formatters/Plural'
import FormatCurrency from 'components/Common/FormatCurrency'
import { ImageParams } from 'components/Common/ResponsiveImage/ResponsiveImage'
import LineCompassIcon from 'components/Luxkit/Icons/line/LineCompassIcon'

const imageParams: ImageParams = {
  aspectRatio: '16:8',
  mobileWidth: '720px',
  fit: 'center',
}

interface Props {
  image: App.Image
  tier: App.LoyaltyTier
  numberOfBenefitRemaining: number
  benefitValue: number
}

function LandingPageLoyaltyTourExpCreditBenefitsModal(props: Props) {
  const { image, tier, numberOfBenefitRemaining, benefitValue } = props

  return (
    <ModalBase size="L">
      <ModalHeader title="Extras on your tour" />
      <ModalBody>
        <ModalImageThumbnail image={image} imageParams={imageParams} />
        <ModalContent>
          <Group direction="vertical" gap={32}>
            {!!numberOfBenefitRemaining && <LoyaltyTierCallOutBanner
              tier={tier}
              subtitle={<BodyText variant="small">{getLoyaltyTierDisplayName(tier)} Member Benefit</BodyText>}
              icon={<LineCompassIcon />}
            >
              <BodyText variant="medium">
                You have {numberOfBenefitRemaining > 1 ? `${numberOfBenefitRemaining}x` : 'a'}{' '}
                <FormatCurrency value={benefitValue} format="dynamic" />{' '}
                <Plural count={benefitValue} singular="voucher" plural="vouchers" />{' '}
                to use on tour optional extras
              </BodyText>
            </LoyaltyTierCallOutBanner>}
            <BodyText variant="large">
              Enjoy extra perks on your next adventure with a travel credit towards tour add-ons.{' '}
              Whether it’s a sunset cruise or a food tour, these extras are on us.
            </BodyText>
            <VerticalSpacer gap={8}>
              <Heading variant="heading4">How it works</Heading>
              <BodyText variant="large">
                Enhance your immersive small-group adventure with <FormatCurrency value={benefitValue} format="dynamic" /> to spend on optional extras.{' '}
                Whether it’s a handpicked cultural experience or a special add-on, you can customise your{' '}
                journey to suit your style.<br /><br />
                With exclusive tours designed by our travel experts and a dedicated tours concierge to assist,{' '}
                it’s seamless from start to finish.<br /><br />
                To activate, purchase a Luxury Escapes tour and contact customer service and we'll organise your voucher.
              </BodyText>
            </VerticalSpacer>
          </Group>
        </ModalContent>
      </ModalBody>
    </ModalBase>
  )
}

export default LandingPageLoyaltyTourExpCreditBenefitsModal
